import { TileIndex } from "../../types";

export const TUTORIAL_LEVEL: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1],
  [1, 0, 12, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1],
  [1, 0, 19, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 15, 0, 9, 0, 0, 2, 0, 0, 1],
  [1, 13, 13, 13, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1],
  [1, 13, 5, 13, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1],
  [1, 13, 13, 13, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
];
